import fillCrudMetadataGaps from '../../fillCrudMetadataGaps';
import authorization from '../../util/authorization';
import { currencies } from '../currencyExchangeRule';

// TODO: criar indice para os campos 'errorMessage' e 'create_request_time'

export default fillCrudMetadataGaps({
  label: 'Reserva Externa',
  labelPlural: 'Reservas Externas',
  name: 'ExternalReservation',
  namePlural: 'ExternalReservations',
  authorization: authorization('master', 'admin'),
  insertable: false,
  updatable: false,
  deletable: false,
  dynamoDB: {
    tableName: 'SpearExternalReservation'
  },
  columns: ['id', 'locator', 'startDate', 'endDate', 'paymentType', 'hotelName', 'netPrice', 'comission', 'currency', 'taxesPrice', 'adultCount', 'childrenCount', 'childrenAges', 'roomDescription', 'clientId', 'meal', 'primaryGuestName', 'primaryGuestEmail', 'primaryGuestCpf', 'errorMessage', 'create_request_time', 'last_update_request_time', 'status'],
  fields: [{
    label: 'Id',
    name: 'id',
    type: 'text',
    updatable: false,
    insertable: false,
    id: true
  }, {
    name: 'locator',
    label: 'Código da reserva no fornecedor',
    type: 'text'
  }, {
    name: 'hotelId',
    label: 'ID do hotel',
    type: 'text'
  }, {
    name: 'hotelName',
    label: 'Nome do hotel',
    type: 'text'
  }, {
    name: 'startDate',
    label: 'Data de check-in',
    type: 'date'
  }, {
    name: 'endDate',
    label: 'Data de check-out',
    type: 'date'
  }, {
    name: 'netPrice',
    label: 'NET',
    type: 'float'
  }, {
    name: 'paymentType',
    label: 'Tipo de Pagamento',
    type: 'text',
    options: [{
      label: 'Cartão Offline',
      value: 'OFF_CC',
      hint: 'Cliente pagará fornecedor com VCN/Cartão'
    }, {
      label: 'Direto no local',
      value: 'DIR',
      hint: 'Cliente pagará fornecedor no local do serviço (hotel/aeroporto/etc) e fornecerá cartão de crédito como garantia'
    }, {
      label: 'Direto no local (IATA)',
      value: 'DIR_IATA',
      hint: 'Cliente pagará fornecedor no local do serviço (hotel/aeroporto/etc) e será usada a garantia IATA da agência'
    }, {
      label: 'Faturado Offline',
      value: 'OFF_FAT',
      hint: 'Cliente pagará fornecedor via fatura'
    }, {
      label: 'Antecipado Offline',
      value: 'OFF_ANT',
      hint: 'Cliente pagará fornecedor antecipadamente'
    }]
  }, {
    name: 'comission',
    label: 'Comissão',
    type: 'float'
  }, {
    name: 'currency',
    label: 'Moeda',
    options: currencies,
    inputType: 'select'
  }, {
    name: 'taxesPrice',
    label: 'Taxas',
    type: 'float'
  }, {
    name: 'adultCount',
    label: 'Adultos',
    type: 'int'
  }, {
    name: 'childrenCount',
    label: 'Crianças',
    type: 'int'
  }, {
    name: 'childrenAges',
    label: 'Idades das crianças',
    type: 'intarray'
  }, {
    name: 'roomDescription',
    label: 'Descrição do quarto',
    type: 'text'
  }, {
    name: 'clientId',
    label: 'Cliente',
    type: 'text'
  }, {
    name: 'meal',
    label: 'Regime alimentar',
    type: 'text'
  }, {
    name: 'primaryGuestName',
    label: 'Nome do hóspede principal',
    type: 'text'
  }, {
    name: 'primaryGuestEmail',
    label: 'Email do hóspede principal',
    type: 'text'
  }, {
    name: 'primaryGuestCpf',
    label: 'CPF do hóspede principal',
    type: 'text'
  }, {
    name: 'status',
    label: 'Status',
    type: 'text'
  }, {
    name: 'guestJourneyStatus',
    label: 'Status de checkout da reserva',
    type: 'text'
  }, {
    name: 'internalReservationId',
    label: 'Id Interno da Reserva',
    type: 'text',
    renderColumn: false
  }, {
    name: 'errorMessage',
    label: 'Mensagem de erro',
    type: 'text'
  }, {
    name: 'create_request_time',
    label: 'Data de criação',
    type: 'datetime'
  }, {
    name: 'last_update_request_time',
    label: 'Data última atualização',
    type: 'datetime'
  }],
  filter: [{
    field: 'errorMessage',
    op: 'isNull'
  }]
});